export const getSecurityAgainstListApi = (query = {}) => {
    const queryString = new URLSearchParams(query).toString();
    return `security-deposit-against${queryString ? `?${queryString}` : ""}`;
};

export const addSecurityAgainstApi = () => {
    return `/security-deposit-against`;
};
export const updateSecurityAgainstApi = (params) => {
    return `/security-deposit-against/${params?.slug}`;
};
export const deleteSecurityAgainstApi = () => {
    return `security-deposit-against`;
};
